module.exports = __webpack_public_path__ + "img/delivery.41667793.png";